"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/no-var-requires */
var TUIChat_json_1 = require("./TUIChat.json");
var TUIConversation_json_1 = require("./TUIConversation.json");
var TUIGroup_json_1 = require("./TUIGroup.json");
var TUIProfile_json_1 = require("./TUIProfile.json");
var TUIContact_json_1 = require("./TUIContact.json");
var TUISearch_json_1 = require("./TUISearch.json");
var message_json_1 = require("./message.json");
var component_json_1 = require("./component.json");
var time_json_1 = require("./time.json");
var words_json_1 = require("./words.json");
var evaluate_json_1 = require("./evaluate.json");
var messages = {
    zh_cn: {
        取消: '取消',
        发送: '发送',
        系统通知: '系统通知',
        关闭: '关闭',
        确定: '确定',
        TUIChat: TUIChat_json_1.default,
        TUIConversation: TUIConversation_json_1.default,
        TUIGroup: TUIGroup_json_1.default,
        TUIProfile: TUIProfile_json_1.default,
        TUIContact: TUIContact_json_1.default,
        message: message_json_1.default,
        component: component_json_1.default,
        time: time_json_1.default,
        Evaluate: evaluate_json_1.default,
        Words: words_json_1.default,
        TUISearch: TUISearch_json_1.default,
    },
};
exports.default = messages;
